import {useRef} from 'react';
import {Platform, StatusBar, Text, TextInput} from 'react-native';
import {GestureHandlerRootView} from 'react-native-gesture-handler';
import {ThemeProvider} from 'styled-components/native';
import {enableScreens} from 'react-native-screens';
import {NavigationContainerRef} from '@react-navigation/native';

import {AppProvider} from './src/context';
import {Routes} from './src/routes';
import {ModalHostProvider} from './src/components/shared/OverlayModal/ModalHost';

import 'react-native-gesture-handler';
import 'react-native-get-random-values';
import Config from 'react-native-config';
import {Dev} from './src/components/shared/Dev';
import {DevMocker} from './src/components/shared/Dev/DevMocker';

import {RFValue} from 'react-native-responsive-fontsize';
import FastImage from 'react-native-fast-image';
import { BlurView } from './web/res/components/BlurView';

interface TextWithDefaultProps extends Text {
  defaultProps: {allowFontScaling?: boolean};
}

interface InputWithDefaultProps extends TextInput {
  defaultProps: {allowFontScaling?: boolean};
}

enableScreens();

interface AppProps {
  clientId?: string;
  token: string;
  theme?: any;
  lat: number;
  lng: number;
  incentiveUserId?: string | null;
  debitoVeicular?: boolean;
}

function AppWeb({clientId, token, theme, lat, lng, incentiveUserId, debitoVeicular}: AppProps) {
  const navigationRef = useRef<NavigationContainerRef<any>>(null);
  // Configurar propriedades padrão para Text e TextInput
  (Text as unknown as TextWithDefaultProps).defaultProps =
    (Text as unknown as TextWithDefaultProps).defaultProps || {};
  (Text as unknown as TextWithDefaultProps).defaultProps.allowFontScaling =
    false;
  (TextInput as unknown as InputWithDefaultProps).defaultProps =
    (TextInput as unknown as InputWithDefaultProps).defaultProps || {};
  (
    TextInput as unknown as InputWithDefaultProps
  ).defaultProps.allowFontScaling = false;

  const appTheme = theme;

  if (!appTheme) {
    return null;
  }

  return (
    //@ts-ignore
    <ThemeProvider theme={appTheme}>
      <GestureHandlerRootView style={{flex: 1}}>
        <StatusBar
          barStyle={Platform.OS === 'ios' ? 'dark-content' : 'light-content'}
          backgroundColor={appTheme.colors.primary}
        />

        <AppProvider>
          <ModalHostProvider>
          <Routes
            ref={navigationRef}
            lat={lat}
            lng={lng}
            token={token}
            incentiveUserId={incentiveUserId}
            clientId={clientId}
            debitoVeicular={debitoVeicular}
          />
          {Config.RN_ENVIRONMENT === 'devtools' && <Dev />}
          {Config.RN_ENVIRONMENT === 'devtools' && <DevMocker navigationRef={navigationRef} />}

          <BlurView
            style={{
              padding: RFValue(5),
              alignItems: 'center',
              backgroundColor: appTheme.colors.background,
              borderTopWidth: 1,
              borderTopColor: appTheme.colors.border_tab,
            }}>

            <Text style={{fontFamily: appTheme.fonts.regular, fontSize: RFValue(10), color: theme.colors.text}}>Powered By</Text>
            <FastImage source={require('./src/assets/images/logo-powered.webp')} style={{width: RFValue(80), height: RFValue(25)}} resizeMode="contain"/>
          </BlurView>
          </ModalHostProvider>
        </AppProvider>
      </GestureHandlerRootView>
    </ThemeProvider>
  );
}

export default AppWeb;
